import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=522a8fb1&scoped=true&"
import script from "./Promocode.vue?vue&type=script&lang=js&"
export * from "./Promocode.vue?vue&type=script&lang=js&"
import style0 from "./Promocode.vue?vue&type=style&index=0&id=522a8fb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a8fb1",
  null
  
)

export default component.exports